import { GetNoticeIdPayload } from "@/data/payload/notice/get-notice-id-payload";
import { NoticeInfoEntity } from "@/domain/entity/notice/notice-info-entity";
import { NoticeRepository } from "@/domain/repository/notice-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class FetchNoticeDetailUsecase {
  constructor(private readonly noticeRepository: NoticeRepository) {}

  async execute(noticeId: string): Promise<SATResult<NoticeInfoEntity, SATError>> {
    const payload: GetNoticeIdPayload = {
      id: noticeId,
    };

    const result = await this.noticeRepository.fetchNoticeDetail(payload);

    if (result.isSuccess) {
      console.log("[FetchNoticeDetailUsecase] :: execute :: 공지사항 상세 조회 성공", result.value);
      return SATResult.success(result.value);
    }

    console.log("[FetchNoticeDetailUsecase] :: execute :: 공지사항 상세 조회 실패", result.error);
    return SATResult.failure(result.error);
  }
}
